const reasons = [
  {
    title: '대구·경북 지역 전문 업체',
    desc: '대구 및 경북 지역에 특화된\n싱크대·주방가구 전문 시공 업체',
  },
  {
    title: '발품 없이 온라인으로 간편하게',
    desc: '사진 한 장으로 집에서 바로 확인하는\n주방 디자인과 무료 견적',
  },
  {
    title: '합리적인 가격, 믿을 수 있는 시공',
    desc: '지역 밀착형 서비스로\n가장 합리적인 가격에 고품질 시공 제공',
  },
];

export default function WhyOnlineSection() {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-base text-gray-500 mb-2">왜,</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
            대구싱크대 키친스는 온라인으로 견적을 먼저 드릴까요?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reasons.map((item, idx) => (
            <div
              key={idx}
              className="bg-gray-50 rounded-lg p-8 border border-gray-100"
            >
              <h3 className="text-lg font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
